import React, { useState } from 'react'
import { Icon, Modal, notification, Upload } from 'antd'
import { get, last, uniqueId } from 'lodash'
import { withTranslation } from 'react-i18next'

import apiService from '../apiService'
import { useDeepCompareEffect } from '../../../hooks'
import { getVar } from '../../../system/support/helpers'

const PictureWall = ({ data, t }) => {
    const uploadWrapperRef = React.createRef()
    const [fileList, setFileList] = useState([])
    const [previewImage, setPreviewImage] = useState()
    const [previewVisible, setPreviewVisible] = useState(false)

    useDeepCompareEffect(() => {
        const fileList = []
        const image_url = getVar(data, 'image_url')
        if (image_url) {
            fileList.push({
                name: image_url,
                status: 'done',
                uid: uniqueId(),
                url: image_url,
            })
        }
        setFileList(fileList)
    }, [data])

    const uploadButton = (
        <div>
            <Icon type="plus" />
            <div className="ant-upload-text">Upload</div>
        </div>
    )

    const handleCancel = () => {
        setPreviewVisible(false)
    }

    const handlePreview = async file => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj)
        }

        setPreviewImage(file.url || file.preview)
        setPreviewVisible(true)
    }

    const updateFileList = fileList => {
        setFileList(fileList)
    }

    const handleChange = data => {
        const { file } = data

        if (file.status === 'done') {
            const newImageUrl = get(data, 'file.response.url')
            const newFile = {
                ...file,
                status: 'done',
                url: newImageUrl,
            }
            updateFileList([newFile])
            return
        }

        if (file.status === 'uploading') {
            updateFileList([file])
        }
    }

    const getBase64 = file => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = () => resolve(reader.result)
            reader.onerror = error => reject(error)
        })
    }

    return (
        <div ref={uploadWrapperRef}>
            <Upload
                accept="image/*"
                className="gflex galign-center"
                fileList={fileList}
                showUploadList={{ showPreviewIcon: true, showRemoveIcon: false }}
                customRequest={async ({ onSuccess, onError, file }) => {
                    try {
                        const formData = new FormData()
                        formData.append('file', file)
                        const packageId = getVar(data, 'package_id')
                        if (fileList.length >= 2) {
                            onError()
                        } else {
                            const { data } = await apiService.uploadProductImageLog(packageId, formData)
                            notification.success({
                                message: t('package:message.upload_image_success'),
                            })
                            onSuccess({
                                url: data,
                            })
                        }
                    } catch (error) {
                        if (get(error, 'response.status') === 401) {
                            notification.error({
                                message: t('auth:message.token_expired'),
                            })
                        } else {
                            notification.error({
                                message: t('message.server_error'),
                            })
                            onError(error)
                        }
                    }
                }}
                listType="picture-card"
                multiple
                onChange={handleChange}
                onPreview={handlePreview}>
                {fileList.length < 2 && uploadButton}
            </Upload>
            <Modal
                visible={previewVisible}
                footer={null}
                onCancel={handleCancel}>
                <img
                    alt="example"
                    style={{ width: '100%' }}
                    src={previewImage}
                />
            </Modal>
        </div>
    )
}

export default withTranslation()(PictureWall)
